import React, {Component} from "react";

import axios from 'axios';
import Constants from '../../../components/Constants/';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class Antecedents extends Component {

  constructor(props) {
    super(props);

    this.refreshAntecedentsList = this.refreshAntecedentsList.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.onAddAntecedent = this.onAddAntecedent.bind(this);

    this.state = {
        antecedentsList: null,
        activePage: 1
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }

      this.refreshAntecedentsList();
    }

    refreshAntecedentsList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/antecedent'
      })
      .then(response => {
          this.setState({
              antecedentsList: response.data
          });
      });
    }

    statusFormatter(cell, row){
      return (
        cell == "ACTIVE" ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>
      );
    }

    actionsFormatter(cell, row){
      return (
        <Button color="info" onClick={() => { alert(cell); }}><i className="fa fa-pencil"></i></Button>
      );
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    afterSaveCell(row, cellName, cellValue) {
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/antecedent',
          data: row
      })
      .then(response => {
        this.msg.show('Antecedente salvo.', {
          time: 10000,
          type: 'success'
        });
      });
    }

    onAddAntecedent(row) {

      row.id = null;
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/antecedent',
          data: row
      })
      .then(response => {
          this.msg.show('Antecedente adicionado.', {
            time: 10000,
            type: 'success'
          });
          this.refreshAntecedentsList();
      });
    }

    createCustomModalHeader(closeModal, save){
      return (
        <InsertModalHeader
          className='model-header'
          title=''
         />
      );
    }


    render() {
      if(this.state.antecedentsList == null) return null;

      const tableOptions = {
        paginationSize: 10,
        hideSizePerPage: true,
        paginationShowsTotal: true,
        paginationShowsTotal: this.renderPaginationShowsTotal,
        onAddRow: this.onAddAntecedent,
        insertModalHeader: this.createCustomModalHeader
      };

      const statusTypes = [ {
        value: 'ACTIVE',
        text: 'Ativo'
      }, {
        value: 'INACTIVE',
        text: 'Inativo'
      }];

      const cellEdit = {
        mode: 'dbclick',
        blurToSave: true,
        afterSaveCell: this.afterSaveCell,
      };

      return(
          <div>
            <h2>Antecedentes</h2>
            <hr />
            <BootstrapTable ref="table" data={this.state.antecedentsList} version='4'
              striped hover pagination insertRow search searchPlaceholder='Pesquisa Geral'
              options={tableOptions} cellEdit={ cellEdit }>
              <TableHeaderColumn dataField="description" dataSort={true} width='40%'>Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="status" editable={ { type: 'select', options: { values: statusTypes } } } dataFormat={this.statusFormatter} dataSort={true} width='25%'>Status</TableHeaderColumn>
              <TableHeaderColumn dataField="id" autoValue isKey={true} width='25%'>ID</TableHeaderColumn>

            </BootstrapTable>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default Antecedents;



// WEBPACK FOOTER //
// ./src/views/admin/Antecedents/Antecedents.js